import PropTypes from "prop-types";
import React from "react";
import NumberFormat from "react-number-format";

const UploadInputField = ({ title, handleDataFetch, id, url }) => {
  const updateInputValue = (event) => {
    let newId = parseInt(event.target.id);
    let newUrl = event.target.value;
    let timeout = null;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      handleDataFetch({
        id: newId,
        url: newUrl,
      });
    }, 1000);
  };

  
  return (
    <div className="upload-file2">
      <h3>{title}</h3>
      <div>
        <div className="upload-file2-item">
          {id === 7 ? (
            <NumberFormat
              id={id}
              defaultValue={url}
              thousandSeparator={true}
              onChange={updateInputValue}
            />
          ) : (
            <input
              id={id}
              type="text"
              defaultValue={url}
              onChange={updateInputValue}
            />
          )}
        </div>
      </div>
    </div>
  );
};

UploadInputField.propTypes = {
  handleDataFetch: PropTypes.func,
  id: PropTypes.number,
  title: PropTypes.string,
  url: PropTypes.string
}

export default UploadInputField;
